export function startOfLocalDay(value?: Date | string | number | null): Date {
  const d =
    value instanceof Date
      ? new Date(value.getTime())
      : value != null && value !== ''
      ? new Date(value)
      : new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function endOfLocalDay(value?: Date | string | number | null): Date {
  const d = startOfLocalDay(value);
  d.setHours(23, 59, 59, 999);
  return d;
}

export function localDateInputValue(value?: Date | string | number | null): string {
  const d =
    value instanceof Date
      ? value
      : value != null && value !== ''
      ? new Date(value)
      : new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
